import BaseProxy from './Proxy';

export default class OrderConfirmationProxy extends BaseProxy {
  constructor(parameters = {}) {
    super('api/substore/order/confirmation', parameters);
  }

  find(subscriptionTemplateId) {
    return this.submit('get', `${this.endpoint}/${subscriptionTemplateId}`);
  }
}
